require("./lib/extracadabra_webfont.css");
require("./font-awesome/css/all.min.css");
// as of august 2022, The Sharp family is not included in the all.css file - you'll need to add the Sharp .css files separately.
// https://fontawesome.com/docs/web/setup/host-yourself/webfonts
require("./font-awesome/css/sharp-solid.min.css");
